import React from 'react';
import styled from 'styled-components';
import MaskedInput from 'react-text-mask';
import Textbox from '@nib-components/textbox';
import FormControl from './NestedFormControl';
const StyledTextbox = styled(Textbox)`
  &&& {
    padding-right: 16px;
  }

  :-webkit-autofill,
  :-webkit-autofill:hover,
  :-webkit-autofill:focus {
    background: #fff;
  }

  -moz-appearance: textfield;

  ::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
    margin: 0;
    -webkit-appearance: none;
  }
`;
StyledTextbox.displayName = 'StyledTextbox';
const NumberTextbox = props => {
  const {
    id = '',
    name = '',
    label = '',
    valid = false,
    validated = false,
    width = 2,
    maxlength = 2,
    autocomplete = '',
    disabled,
    handleChange,
    handleBlur,
    handleKeyDown,
    min,
    max,
    mask,
    ...otherProps
  } = props;
  return React.createElement("div", null, React.createElement(FormControl, {
    id: id,
    name: name,
    label: label,
    valid: valid,
    validated: validated,
    width: width,
    disabled: disabled
  }, React.createElement(MaskedInput, {
    guide: false,
    mask: mask,
    ...props.field,
    render: (ref, props) => React.createElement(StyledTextbox, {
      ref: ref,
      ...props,
      ...otherProps,
      inputMode: "numeric",
      onChange: handleChange,
      onKeyDown: handleKeyDown,
      onBlur: handleBlur,
      pattern: "\\d*",
      autoComplete: autocomplete,
      ...(min && {
        min,
        max
      })
    })
  })));
};
NumberTextbox.defaultProps = {
  id: '',
  name: '',
  label: '',
  valid: false,
  validated: false,
  width: 2,
  maxlength: 2,
  autocomplete: ''
};
export default NumberTextbox;